import React, { useState } from "react";
import { FaSave } from 'react-icons/fa';
import InternalHeader from '../InternalHeader';
import Sidebar from '../Sidebar';
import '../Patients/CreatePatient.css'; // Assuming you're using the same CSS
import AccessControl from '../AccessControl';
import LinkMap from '../LinkMap/LinkMap';

const CreateStores = ({ onAddItem }) => {
    const [isSidebarVisible, setIsSidebarVisible] = useState(true);
    const [newItem, setNewItem] = useState({
        StoreName: "",
        StoreContact: "",
        StoreAddress: "",
    });
    const linkData = [
        { label: 'Inventory', path: '/inventory' },
        { label: 'Create Suppliers', path: '/create-suppliers' },
    ];

    const toggleSidebar = () => {
        setIsSidebarVisible(!isSidebarVisible);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewItem({
            ...newItem,
            [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch('https://api.hgcdental.clinic/api/stores', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(newItem),
            });

            if (!response.ok) {
                const errorData = await response.json(); // Parse the error response
                console.error('Server error:', errorData);
                throw new Error('Server responded with an error');
            }

            const data = await response.json();
            if (onAddItem && typeof onAddItem === 'function') {
                onAddItem(data); // Notify the parent component to add the new item
            }
        } catch (error) {
            console.error('Error adding item:', error);
        }
    };

    return (
        <AccessControl>
            <div className={`create-patient-container ${isSidebarVisible ? 'sidebar-visible' : 'sidebar-hidden'}`}>
                <InternalHeader moduleName="Create Store" toggleSidebar={toggleSidebar} />
                <div className="create-patient-content">
                    <Sidebar isSidebarVisible={isSidebarVisible} />
                    <div className="create-patient">
                        <LinkMap
                            links={linkData}
                            moduleName="Inventory"
                            moduleIcon="inventory"
                        />
                        <div>
                            <button className="create-patient-button" onClick={handleSubmit}>
                                <FaSave /> Save
                            </button>
                        </div>
                        <div className="create-patient-form">
                            <h2>Create New Supplier</h2>
                            {/* Store Name Field */}
                            <div className="input-group">
                                <label className="label">Supplier Name</label>
                                <input
                                    type="text"
                                    name="StoreName"
                                    value={newItem.StoreName}
                                    onChange={handleInputChange}
                                    className="input-field"
                                    required
                                />
                            </div>

                            {/* Store Contact Field */}
                            <div className="input-group">
                                <label className="label">Store Contact</label>
                                <input
                                    type="text"
                                    name="StoreContact"
                                    value={newItem.StoreContact}
                                    onChange={handleInputChange}
                                    className="input-field"
                                    required
                                />
                            </div>

                            <div className="input-group">
                                <label className="label">Store Address</label>
                                <input
                                    type="text"
                                    name="StoreAddress"
                                    value={newItem.StoreAddress}
                                    onChange={handleInputChange}
                                    className="input-field"
                                    required
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AccessControl>
    );
};

export default CreateStores;